import { computed, ref, watchEffect } from 'vue'
import { useAuth } from '@/entities/Auth'
import { type InventTab, useLoadTabs } from '@/entities/Manuals/Tabs'
import { useHelpers } from '@/shared/lib'

export const useModel = () => {
  const { isTab } = useAuth()
  const { isMobileDevice } = useHelpers()

  const tabsData = ref<InventTab[]>([])

  /**
   * Функция загрузки данных
   */
  const loadData = () => {
    const result = useLoadTabs()

    watchEffect(() => {
      if (result.data.value) {
        tabsData.value = result.data.value.data || []
      }
    })

    return result
  }

  /** Вычисляем список меню */
  const menu = computed(() => {
    return tabsData.value.filter(
      (item) =>
        item.is_show &&
        item.params.tabs.some((item: string) => isTab(item)) &&
        (!isMobileDevice() || (item.is_mobile && isMobileDevice())),
    )
  })

  return {
    menu,

    loadData,
  }
}
